import { dk } from "./fieldKey";

/**
 * The always-available "map to an iconik comment" destination (Seth Tanner, Monday 12926430722).
 * Unlike every other destination on this tab, Comments isn't drawn from either of the org's
 * configured metadata views — there's no `to_view_id`/`to_field_id` for it at all (see
 * `apps/customer-api/src/services/customerSpotterMapping.ts`'s module doc comment for the full
 * wire-shape story) — so it needs its own sentinel identity distinct from any real view/field id,
 * purely for this app's internal `${viewId}::${viewScope}::${fieldName}` row-key bookkeeping
 * (`fieldKey.ts`'s `dk`/`parseDk`). None of this ever reaches the wire: `FieldsScreen.tsx`'s
 * `handleSave` sends `destination: "comment"` instead, never these sentinel strings.
 *
 * `COMMENT_DESTINATION_SCOPE` ("segment") DOES reach the wire, same as any other row's `scope` —
 * `handleSave` sends it unconditionally, and the backend stores whatever's submitted (see
 * `mapping.ts`'s/`fields.ts`'s `sanitizeEntry`/`sanitizeMappedField`). It does NOT drive the
 * Source dropdown's option list — `FieldsScreen.tsx` special-cases `COMMENT_DESTINATION_KEY` to
 * show the full catalogue there, since Comments isn't tied to any view/scope. No backend/n8n
 * logic reads `scope` off a comment entry today, but nothing prevents it from starting to — this
 * value isn't a dead/discarded one.
 */
export const COMMENT_DESTINATION_VIEW_ID = "__comment__";
export const COMMENT_DESTINATION_FIELD_NAME = "__comment__";
export const COMMENT_DESTINATION_SCOPE: "asset" | "segment" = "segment";
export const COMMENT_DESTINATION_KEY = dk(
  COMMENT_DESTINATION_VIEW_ID,
  COMMENT_DESTINATION_SCOPE,
  COMMENT_DESTINATION_FIELD_NAME
);
